import { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../../Contexts/AuthContext'
import { MobileMenuProvider } from '../../Contexts/MobileMenuContext'
import MobileMoreSheet from './MobileMoreSheet'
import MobileTabBar from './MobileTabBar'

type MobileLayoutProps = {
  children: ReactNode
}

// Routes qui ont leur propre navigation mobile (pas de tab bar globale)
const ROUTES_WITHOUT_TAB_BAR = ['/damage']

const MobileLayout = ({ children }: MobileLayoutProps) => {
  const { isAuthenticated } = useAuth()
  const location = useLocation()

  if (!isAuthenticated) {
    return <>{children}</>
  }

  const hideTabBar = ROUTES_WITHOUT_TAB_BAR.some(route =>
    location.pathname.startsWith(route),
  )

  return (
    <MobileMenuProvider>
      <div className="flex h-screen flex-col">
        <div className={`flex-1 overflow-y-auto ${hideTabBar ? '' : 'pb-14'} md:pb-0`}>
          {children}
        </div>
        <MobileTabBar />
        <MobileMoreSheet />
      </div>
    </MobileMenuProvider>
  )
}

export default MobileLayout
